import React from "react"
import PropTypes from "prop-types"
import Typography from "@material-ui/core/Typography"
import { withStyles } from "@material-ui/core/styles"

const styles = theme => ({
	root: {
		display: "flex",
		flexDirection: "column",
		padding: theme.spacing ( 8 ),
		width: "100%",
		borderBottom: `solid 1px ${theme.palette.divider}`,
		[theme.breakpoints.down ("md")]: {
			padding: theme.spacing ( 4 )
		}
	},
})

class Section extends React.Component {

	render () {
		const { classes, children, id } = this.props
		return <section id={id} className={classes.root} >
			{children}
		</section>
	}

}

Section.propTypes = {
	classes: PropTypes.object.isRequired,
	children: PropTypes.node.isRequired,
	id: PropTypes.string.isRequired
}

export default withStyles ( styles ) ( Section )
